module.exports = __webpack_public_path__ + "img/54276849__3.8d56e34d.jpg";